import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useOrderStore } from "../../stores/useOrderStores";
import "./MyOrder.css";

const API_ORIGIN = (
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:5000/api"
).replace(/\/api\/?$/, "");

const resolveImage = (imagePath) => {
  if (!imagePath) {
    return "https://via.placeholder.com/150";
  }

  return imagePath.startsWith("http")
    ? imagePath
    : `${API_ORIGIN}/${imagePath.replace(/^\/+/, "")}`;
};

const MyOrder = () => {
  const {
    orders = [],
    loading,
    error,
    getOrders,
  } = useOrderStore();

  useEffect(() => {
    getOrders().catch(() => {});
  }, [getOrders]);

  const sortedOrders = [...orders].sort(
    (firstOrder, secondOrder) =>
      new Date(secondOrder.createdAt) -
      new Date(firstOrder.createdAt)
  );

  if (loading && orders.length === 0) {
    return (
      <div className="orders-page">
        <p className="no-orders">
          Loading your orders...
        </p>
      </div>
    );
  }

  if (error && orders.length === 0) {
    return (
      <div className="orders-page">
        <p className="no-orders">{error}</p>
      </div>
    );
  }

  return (
    <div className="orders-page">
      {orders.length === 0 ? (
        <p className="no-orders">
          You have no orders yet.
        </p>
      ) : (
        <>
          <div className="order-header">
            <h2>THANK YOU FOR YOUR ORDERS !</h2>
          </div>

          {sortedOrders.map((order) => {
            const orderProducts =
              order.order_products ||
              order.orderDetails ||
              [];

            return (
              <div
                key={order.id}
                className="order-item"
              >
                {orderProducts.map((detail) => {
                  const product =
                    detail.product || {};

                  const imagePath =
                    product.product_images?.[0]
                      ?.image_url ||
                    product.images?.[0]?.image_url ||
                    product.image;

                  return (
                    <div
                      key={
                        detail.id ||
                        `${detail.product_id}-${detail.size}`
                      }
                      className="product-container"
                    >
                      <img
                        src={resolveImage(imagePath)}
                        alt={
                          product.name || "Product"
                        }
                        className="product-image"
                        loading="lazy"
                        decoding="async"
                      />

                      <div className="product-info">
                        <h3>Order #{order.id}</h3>

                        <p className="product-name">
                          {product.name || "Product"}
                        </p>

                        <p className="product-quantity">
                          x{detail.quantity}
                        </p>

                        <p className="product-size">
                          {detail.size || "N/A"}
                        </p>

                        <p className="product-color">
                          {product.color || ""}
                        </p>

                        <p className="product-price">
                          ₦{order.total_price}
                        </p>

                        <p>
                          Status:{" "}
                          {order.order_status}
                        </p>

                        <p>
                          Date:{" "}
                          {new Date(
                            order.createdAt ||
                              order.order_date
                          ).toLocaleDateString()}
                        </p>

                        <p>
                          Shipping Address:{" "}
                          {order.shipping_address}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}

          <Link
            to="/"
            className="continue-shopping"
          >
            CONTINUE SHOPPING
          </Link>
        </>
      )}
    </div>
  );
};

export default MyOrder;